<template>
  <div class="container mt-lg-5 mb-5">
    <form @submit.prevent="saveChanges" class="d-flex flex-column gap-2">
      <div class="d-flex flex-row">
        <h2>{{ $t('completarDatosParaIngresar') }}</h2>
      </div>

      <div class="d-flex flex-lg-row flex-column gap-2">
        <p class="m-0 fs-7 w-100"><strong>{{ $t('apellido') }}:</strong> <input type="text" v-model="persona.Apellido" class="form-control sombra" maxlength="100" :disabled="true" required/></p>
        <p class="m-0 fs-7 w-100"><strong>{{ $t('nombre') }}:</strong> <input type="text" v-model="persona.Nombre" class="form-control sombra" maxlength="100" :disabled="true" required/></p>
      </div>
      <!-- Email - Permitir múltiples emails -->
      <div class="d-flex flex-column">
        <label for="email" class="form-label m-0 fs-7"><strong>{{ $t('emailsPersonales') }}*:</strong></label>
        <div v-for="(email, index) in persona?.Email?.filter(email => !email.TipoEmail == 'Profesional')" :key="'email' + index" class="m-0 fs-7 d-flex flex-row gap-2 mb-2">
          <input type="email" v-model="email.email" class="form-control sombra" maxlength="100" :disabled="originalPersona.Email.find( e => e.IdEmail == email.IdEmail )?.email!=null && originalPersona.Email.find( e => e.IdEmail == email.IdEmail )?.email!=''" required/>
          <button type="button" class="btn btn-danger sombra" @click="removeEmail(index+1)" v-if="index >= 1">{{ $t('eliminar') }}</button>
        </div>
        <button type="button" class="btn btn-primary mt-2 sombra" @click="addEmail">{{ $t('agregarEmail') }}</button>
      </div>

      <div class="d-flex flex-lg-row flex-column gap-2">
        <p class="m-0 fs-7 w-100"><strong>{{ $t('dni') }}:</strong> <input type="text" v-model="persona.Dni" class="form-control sombra" :disabled="originalPersona.Dni != null && originalPersona.Dni!= ''"/></p>
        <p class="m-0 fs-7 w-100"><strong>{{ $t('pasaporte') }}:</strong> <input type="text" v-model="persona.Pasaporte" class="form-control sombra" maxlength="50" :disabled="originalPersona.Dni != null && originalPersona.Dni!= ''"/></p>
      </div>
      <div class="d-flex flex-lg-row flex-column gap-2 w-100">
        <!-- Genero -->
        <div class="d-flex flex-column w-100">
          <label for="genero" class="form-label m-0 fs-7"><strong>{{ $t('genero') }}*:</strong></label>
          <div class="select-wrapper">
            <select id="genero" v-model="persona.Genero" class="form-select sombra" :disabled="originalPersona.Genero != null && originalPersona.Genero != ''" required>
              <option value="M">{{ $t('masculino') }}</option>
              <option value="F">{{ $t('femenino') }}</option>
              <option value="X">{{ $t('noBinario') }}</option>
              <option value="-">{{ $t('prefieroNoDecirlo') }}</option>
            </select>
            <svg class="select-icon" viewBox="0 0 20 20" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
              <path d="M5.23 7.21a.75.75 0 0 1 1.06.02L10 11.06l3.71-3.83a.75.75 0 1 1 1.08 1.04l-4.25 4.4a.75.75 0 0 1-1.08 0l-4.25-4.4a.75.75 0 0 1 .02-1.06z"/>
            </svg>
          </div>
        </div>
        <p class="m-0 fs-7 w-100"><strong>{{ $t('fechaNacimiento') }}*:</strong> <input type="date" v-model="persona.FechaNac" class="form-control sombra" :disabled="originalPersona.FechaNac != null" required/></p>
      </div>

      <!-- Nivel/Sector -->
      <div class="d-flex flex-column w-100">
        <label for="estadoCivil" class="form-label m-0 fs-7"><strong>{{ $t('nivelSector') }}*:</strong></label>
        <div class="select-wrapper">
          <select id="estadoCivil" v-model="selectedNivelSectorId" class="form-select sombra" :disabled="selectedNivelSectorIdOriginal != null && selectedNivelSectorIdOriginal != ''" required>
            <option v-for="(nivelSector) in nivelesSectores.Listas" :key="nivelSector.IdLista" :value="nivelSector.IdLista">{{ nivelSector.Nombre }}</option>
          </select>
          <svg class="select-icon" viewBox="0 0 20 20" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
            <path d="M5.23 7.21a.75.75 0 0 1 1.06.02L10 11.06l3.71-3.83a.75.75 0 1 1 1.08 1.04l-4.25 4.4a.75.75 0 0 1-1.08 0l-4.25-4.4a.75.75 0 0 1 .02-1.06z"/>
          </svg>
        </div>
      </div>

      <div class="d-flex flex-row gap-2">
        <button class="btn btn-success sombra" type="submit">{{ $t('guardar') }}</button>
        <router-link class="btn btn-secondary sombra text-center" to="/login">{{ $t('cancelar') }}</router-link>
        <div v-if="loading" class="loading-spinner d-flex flex-row align-items-center justify-content-center">
          <img src="../assets/LOADING.gif" style="width: 40px;" alt="Cargando..." />
        </div>
      </div>
    </form>
  </div>
</template>

<script>
  import { ref, onMounted, computed } from 'vue';
  import {useStore} from "vuex";
  import {useRouter} from "vue-router";
  import { useI18n } from 'vue-i18n';
  import api from '@/services/api';

export default {
  name: 'CompletarDatosBasicos',
  setup() {
    const { t } = useI18n();
    var isEditing = ref(false);
    var loading = ref(false);
    var loadingProvincias = ref(false);
    const router = useRouter();
    const store = useStore();
    const user = computed(() => store.state.user);
    const persona = ref({});
    const originalPersona = ref({});
    const nivelesSectores = ref({});
    const paises = ref({});
    const provincias = ref({});
    const provinciasArg = ref({});
    const estadoCivil = ref({});
    const nacionalidades = ref({});
    let selectedNivelSectorId = ref('');
    let selectedNivelSectorIdOriginal = ref('');
    var hasEditarDatosPersonalesPermission = ref(false);

    const fetchPersona = async () => {
      try {
        loading.value = true;
        const response = await api.get(`api/Persona/`+user?.value.idPersona);
        persona.value = response.data; // Asumiendo que la respuesta contiene un array de usuarios
        // if (persona.value.PersonasNacionalidads.length === 0) {
        //   persona.value.PersonasNacionalidads = [{ IdNacionalidad: "", IdPersona: null }];
        // }
        if (persona.value.Email.filter(e => !e.TipoEmail == 'Profesional').length === 0) {
          persona.value.Email.push({ IdEmail: generarUUID(), email: null, Principal: false });
        }

        const existingNivelSectorPog = persona.value.PersonasListas.find(pog =>
          pog.Lista &&
          pog.Lista.IdGrupo == '555f125b-184f-4b46-97b4-7d4b54a56858'
        );

        if (existingNivelSectorPog) {
          selectedNivelSectorId.value = existingNivelSectorPog.IdLista
          selectedNivelSectorIdOriginal.value = existingNivelSectorPog.IdLista
        }

        // if(persona.value.ProvinciaNacimiento!=null){
        //   fetchProvincias(persona.value.PaisNacimiento.IdPais)
        // }
        console.log(persona.value)
        originalPersona.value = JSON.parse(JSON.stringify(persona.value));
        loading.value = false;
      } catch (error) {
        console.error('Error al obtener datos del usuario:', error);
      }
    };
    
    const fetchNivelSector = async () => {
      try {
        const response = await api.get(`api/Grupos/555F125B-184F-4B46-97B4-7D4B54A56858`);
        nivelesSectores.value = response.data; // Asumiendo que la respuesta contiene un array de usuarios
        //console.log(paises.value)
      } catch (error) {
        console.error('Error al obtener datos del usuario:', error);
      }
    };

    const fetchPaises = async () => {
      try {
        const response = await api.get(`api/ExtrasPersonas/Paises`);
        paises.value = response.data; // Asumiendo que la respuesta contiene un array de usuarios
        //console.log(paises.value)
      } catch (error) {
        console.error('Error al obtener datos del usuario:', error);
      }
    };

    const fetchProvincias = async (idPais) => {
      try {
        loadingProvincias.value=true
        const response = await api.get(`api/ExtrasPersonas/Provincias/ByPais/`+idPais);
        provincias.value = response.data; // Asumiendo que la respuesta contiene un array de usuarios
        const responseArgentina = await api.get(`api/ExtrasPersonas/Provincias/ByPais/1f3517df-5c00-471b-8883-91d73a902eb4`);
        provinciasArg.value = responseArgentina.data
        //console.log(provincias.value)
        loadingProvincias.value=false
      } catch (error) {
        console.error('Error al obtener datos del usuario:', error);
      }
    };

    const fetchEstadoCivil = async () => {
      try {
        const response = await api.get(`api/ExtrasPersonas/EstadosCiviles`);
        estadoCivil.value = response.data; // Asumiendo que la respuesta contiene un array de usuarios
        //console.log(estadoCivil.value)
      } catch (error) {
        console.error('Error al obtener datos del usuario:', error);
      }
    };

    const fetchNacionalidades = async () => {
      try {
        const response = await api.get(`api/ExtrasPersonas/Nacionalidades`);
        nacionalidades.value = response.data; // Asumiendo que la respuesta contiene un array de usuarios
        //console.log(nacionalidades.value)
      } catch (error) {
        console.error('Error al obtener datos del usuario:', error);
      }
    };

    const saveChanges = async () => {
      try {
        // if(persona.value.PersonasNacionalidads == null || persona.value.PersonasNacionalidads.length == 0 || persona.value.PersonasNacionalidads.some(pn => pn.IdNacionalidad == '')){
        //   alert('Porfavor agregar al menos 1 nacionalidad');
        //   throw new Error('Porfavor agregar al menos 1 nacionalidad')
        // }

        const existingNivelSectorPog = persona.value.PersonasListas.find(pog =>
          pog.Lista &&
          pog.Lista.IdGrupo === '555f125b-184f-4b46-97b4-7d4b54a56858'
        );

        if (existingNivelSectorPog) {
          existingNivelSectorPog.IdLista = selectedNivelSectorId.value
        }
        else{
          const PersonasListas = {
            IdPersona: user?.value.idPersona,
            IdLista: selectedNivelSectorId.value
          }
          if(persona.value.PersonasListas == null){
            persona.value.PersonasListas = []
          }
          persona.value.PersonasListas.push(PersonasListas)
        }

        convertEmptyToNull(persona.value)
        console.log(persona.value)
        await api.put(`api/Persona`, persona.value);


        let redirectUrl = localStorage.getItem('redirectAfterLogin') || '/';
        if(redirectUrl=="/login"){
          redirectUrl="/";
        }

        localStorage.removeItem('redirectAfterLogin');
        // Redirige al usuario
        await router.push(redirectUrl);

        
        isEditing.value = false;
      } catch (error) {
        console.error('Error al guardar los cambios:', error);
        alert('Hubo un problema al guardar los datos:', error);
      }
    };
    const generarUUID = () => {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        const r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
      });
    }

    const convertEmptyToNull = (obj) => {
      Object.keys(obj).forEach((key) => {
        if (obj[key] === "") {
          obj[key] = null;
        }
      });
    }


    const addEmail = () => {
      // Añadir un nuevo objeto email vacío
      persona.value.Email.push({ IdEmail: generarUUID(), email: "", Principal: false });
      console.log(persona.value)
    };
    const removeEmail = (index) => {
      // Eliminar la nacionalidad en el índice dado
      persona.value.Email.splice(index, 1);
    };
    const addNacionalidad = () => {
      // Añadir un nuevo objeto nacionalidad vacío
      persona.value.PersonasNacionalidads.push({ IdNacionalidad: null});
    };
    const removeNacionalidad = (index) => {
      // Eliminar la nacionalidad en el índice dado
      persona.value.PersonasNacionalidads.splice(index, 1);
    };
    const addIdiomas = () => {
      // Añadir un nuevo objeto nacionalidad vacío
      persona.value.PersonasIdiomas.push({ IdIdioma: null});
    };
    const removeIdiomas = (index) => {
      // Eliminar la nacionalidad en el índice dado
      persona.value.PersonasIdiomas.splice(index, 1);
    };

    onMounted(() => {
      const lastUpdate = localStorage.getItem("lastUpdate");
      const today = new Date().toISOString().split("T")[0]; // Obtiene solo la fecha (YYYY-MM-DD)

      if (lastUpdate !== today) {
        localStorage.setItem("lastUpdate", today);
        window.location.reload(); // Recarga la página solo si no se ha recargado hoy
      }
      
      fetchPersona();
      fetchPaises();
      fetchNacionalidades();
      fetchEstadoCivil();
      fetchNivelSector();
    });

    return {
      t,
      persona,
      isEditing,
      loading,
      loadingProvincias,
      paises,
      provincias,
      provinciasArg,
      estadoCivil,
      nacionalidades,
      fetchProvincias,
      saveChanges,
      addEmail,
      removeEmail,
      addNacionalidad,
      removeNacionalidad,
      addIdiomas,
      removeIdiomas,
      hasEditarDatosPersonalesPermission,
      nivelesSectores,
      selectedNivelSectorId,
      selectedNivelSectorIdOriginal,
      originalPersona,
    };
  },
};
</script>

<style>
.permissions-list {
  margin-top: 10px;
}
</style>
